<form [formGroup]="bulkDownloadForm" class="component-events-download-container">
  <label style="font-size:1.2rem;">Select download type</label>
  <div class="row space-above">
    <mat-radio-group formControlName="selectedFileType" class="radio-group">
      @for (fileFormat of fileDownloadTypes; track fileFormat) {
        <mat-radio-button [value]="fileFormat.value">
          {{fileFormat.display}}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
  @if (!!bdForm.selectedFileType.value && bdForm.selectedFileType.value !== 'files') {
    <mat-form-field class="bordered-select space-above" >
      <mat-label>Select formatting to apply</mat-label>
      <mat-select formControlName="selectedFileFormat"
        class="page-field-select"
        style="margin: 0 0 20px;">
        @for (option of filteredFileOptions; track option) {
          <mat-option [value]="option.value">
            {{option.title}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @if (!!bdForm.selectedFileType.value && bdForm.selectedFileType.value === 'files') {
    <div class="row space-above" >
      <select-many-constant-properties
        [value]="fileConstantProperties"
        [custom_filters]="filePropertyFilter"
        label="Select file Constant Properties to download">
      </select-many-constant-properties>
    </div>
  }
  <div class="row btn-action">
    <div class="btn-download" (click)="downloadClicked()">Download</div>
  </div>
</form>
